import { render, staticRenderFns } from "./CategoryDetail.vue?vue&type=template&id=b38a1e04&"
import script from "./CategoryDetail.vue?vue&type=script&lang=js&"
export * from "./CategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports